export { default } from './SkeletonLowestRatesPropertiesMobile';
